import '.l{display:flex;}.ssr-plugin'
import '.az{align-items:stretch;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ci{background:var(--palette-white);}.ssr-plugin'
import '.cd{flex-grow:1;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.bk{max-width:77.5rem;}.ssr-plugin'
import '.ek{justify-content:stretch;}.ssr-plugin'
import '.el{position:sticky;}.ssr-plugin'
import '.dd{top:0;}.ssr-plugin'
import '.em{z-index:10;}.ssr-plugin'
import '.en{padding-block:1rem;}.ssr-plugin'
import '.eo{height:3rem;}.ssr-plugin'
import '.ax{justify-content:space-between;}.ssr-plugin'
import '.a7{flex-wrap:wrap;}.ssr-plugin'
import '.ep{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bi{margin-top:2rem;}.ssr-plugin'
import '.eq{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="l az a1 m ci"
      >
        <div className="cd l aa a1 m"
        >
          <div className="bk l m ek el dd em ci"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="en eo l ax aa a7"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ep l m az bi eq bk"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
